import { ActionIcon, Tooltip } from '@mantine/core';
import { IconDownload } from '@tabler/icons-react';

type Props = {
  onDownload: () => void;
};

export default function DownloadDocumentControl({ onDownload }: Props) {
  return (
    <Tooltip label="Download" withArrow>
      <ActionIcon
        variant="subtle"
        c="brand.7"
        bg="brand.0"
        size={20}
        radius={8}
        aria-label="Download document"
        onClick={e => {
          e.stopPropagation();
          onDownload();
        }}
      >
        <IconDownload size={16} stroke={1.5} />
      </ActionIcon>
    </Tooltip>
  );
}
